<template>
  <div class="lz-form-card">
    <div class="lz-panel-title">
      <span class="lz-panel-icon-wrap"><b-icon icon="pencil-fill"></b-icon></span>
      New Entry
    </div>

    <project-selector
      v-if="FormLayouts['FrmProject']"
      :activityType="activityType" />
    <holiday-type-selector v-if="FormLayouts['FrmHolidayType']" />
    <date-selector
      v-if="FormLayouts['FrmDate']"
      :activityType="activityType"
      :dateRangeSelected="FormLayouts['FrmDateRange']" />
    <days-requested-selector v-if="FormLayouts['FrmTotalDays']" />
    <categories-selector v-if="FormLayouts['FrmCategories']" />

    <div
      class="lz-field-row"
      v-if="FormLayouts['FrmAmount'] || FormLayouts['FrmVAT']">
      <amount-selector v-if="FormLayouts['FrmAmount']" />
      <vat-selector v-if="FormLayouts['FrmVAT']" />
    </div>

    <hours-selector v-if="FormLayouts['FrmHours']" />
    <attachment-selector v-if="FormLayouts['FrmReceipt']" />
    <manager-selector v-if="FormLayouts['FrmManager']" />
    <notes-selector v-if="FormLayouts['FrmNotes']" />

    <div class="lz-form-actions">
      <b-button size="sm" variant="info" class="lz-add-btn" @click="addEntry">
        <b-icon icon="plus-lg"></b-icon>
        <span>Add to queue</span>
        <b-icon icon="plus-lg" class="lz-add-btn-spacer" aria-hidden="true"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
import ProjectSelector from './form-components/ProjectSelector.vue'
import DateSelector from './form-components/DateSelector.vue'
import HoursSelector from './form-components/HoursSelector.vue'
import NotesSelector from './form-components/NotesSelector.vue'
import CategoriesSelector from './form-components/CategoriesSelector.vue'
import AmountSelector from './form-components/AmountSelector.vue'
import AttachmentSelector from './form-components/AttachmentSelector.vue'
import ManagerSelector from './form-components/ManagerSelector.vue'
import HolidayTypeSelector from './form-components/HolidayTypeSelector.vue'
import VatSelector from './form-components/VATSelector.vue'
import DaysRequestedSelector from './form-components/DaysRequestedSelector.vue'

export default {
  name: 'ActivityForm',
  props: ['activityType'],
  components: {
    CategoriesSelector,
    ProjectSelector,
    DateSelector,
    HoursSelector,
    NotesSelector,
    AmountSelector,
    AttachmentSelector,
    ManagerSelector,
    HolidayTypeSelector,
    VatSelector,
    DaysRequestedSelector
  },
  data() {
    return {
      generateForm: false,
      holidayOptions: []
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    FormLayouts() {
      return this.Store.formLayouts
    },
    items() {
      return this.$store.getters.activityItems
    }
  },
  mounted() {
    this.$root.$once('holidayTypeOptions', (list) => {
      this.holidayOptions = list
    })
    this.selectType(null, this.activityType)
  },
  methods: {
    selectType(ev, val = null) {
      try {
        let key = ev?.target?.value ?? val
        if (!key) {
          return
        }
        let layoutsToShow = []
        switch (key) {
          case 'hld':
            layoutsToShow = ['HolidayType', 'Date', 'DateRange', 'TotalDays']
            break
          case 'exp':
            layoutsToShow = [
              'Project',
              'Date',
              'Categories',
              'Amount',
              'Receipt',
              'Manager',
              'VAT'
            ]
            break
        }
        layoutsToShow = layoutsToShow.concat(['Notes'])
        layoutsToShow = layoutsToShow.map((layout) => `Frm${layout}`)
        for (let layout in this.FormLayouts) {
          this.$store.commit('setFormLayouts', {
            layout,
            show: layoutsToShow.indexOf(layout) !== -1
          })
        }
        this.generateForm = true
      } catch (Exception) {
        this.resetForm(true)
        console.log({ Exception: Exception.message })
      }
    },
    resetForm() {
      this.$store.commit('resetFormData')
      this.$store.commit('resetFormLayouts')
      this.generateForm = false
    },
    async addEntry() {
      let isValid = true
      let errormsg = []
      let newEntry = {}
      const typesMap = {
        def: null,
        hld: 'holiday',
        exp: 'expense'
      }
      this.$store.commit('modifyFormData', {
        key: 'type',
        value: this.activityType
      })
      for (let key in this.FormData) {
        let val = this.FormData[key]
        let valType = Object.prototype.toString.call(val)
        valType = valType.substr(valType.indexOf(' ') + 1, 3).toLowerCase()
        switch (key) {
          case 'type':
            newEntry[key] = typesMap[val]
            break
          case 'project':
            newEntry[key] = val === 'def' ? null : val
            break
          case 'dates':
            if (valType !== 'arr') {
              val = [val, val]
            }
            newEntry[key] = val
            break
          case 'duration':
            if (parseFloat(val) > 18) {
              isValid = false
              errormsg.push(
                'Maximum allowed hours to be added per day are 18 hours.'
              )
            }
            newEntry[key] = parseFloat(val)
            break
          case 'vat':
            newEntry[key] = val.amount
            break
          default:
            newEntry[key] = val
        }
      }
      if (newEntry.type === 'expense') {
        isValid =
          isValid && newEntry.file && typeof newEntry.file !== 'undefined'
        if (!isValid) {
          errormsg.push(`you have to attach the expense bill`)
        }
        newEntry['ProjectCode'] = newEntry?.project ?? null
        newEntry['Description'] = newEntry?.notes ?? null
        newEntry['AttachmentObjectKey'] = newEntry?.file ?? null
      }
      if (newEntry.type == 'holiday') {
        newEntry.holidayLabel =
          this.holidayOptions.find((itm) => {
            if (!newEntry.holidayType) {
              return {}
            }
            if (
              itm.value ==
                newEntry.holidayType.toUpperCase() +
                  newEntry.holidayHalfDayMeridiem ||
              itm.value == newEntry.holidayType
            ) {
              return itm
            }
            return null
          })?.text ?? 'N/A'
      }
      isValid =
        isValid && Object.values(typesMap).slice(1).includes(newEntry.type)
      if (!isValid) errormsg.push(`type "${newEntry.type}" is not valid`)
      if (newEntry.type === 'expense') {
        isValid = isValid && newEntry.project !== null
        if (!isValid) errormsg.push(`selected project is not valid`)
      }
      if (newEntry.type === 'holiday') {
        isValid = isValid && newEntry.holidayType !== null
        if (!isValid) errormsg.push(`selected holiday type is not valid`)
      }
      newEntry.dates = newEntry.dates.filter((dt) => dt !== null)
      isValid = isValid && newEntry.dates.length
      if (!isValid) errormsg.push(`selected date is not valid`)
      if (isValid && newEntry.type === 'holiday') {
        newEntry.duration = this.FormData.totalDays
      }
      isValid = isValid && newEntry.duration > 0
      if (!isValid) errormsg.push(`selected dates are not valid`)
      if (isValid && newEntry.type === 'expense') {
        isValid = isValid && newEntry.category !== 'def'
        if (!isValid) errormsg.push(`selected category are not valid`)
      }
      if (!isValid) {
        return this.sendErrNotif('Error: ' + errormsg[0])
      }
      newEntry = this.ObjFilter(newEntry, (val) => val !== null)
      // if (this.isDuplicated(newEntry)) {
      //   return this.sendErrNotif('Record already exists.')
      // }
      this.$store.commit('addActivityEntry', {
        list: newEntry.type === 'expense' ? 'expenseItems' : 'holidayItems',
        item: newEntry
      })
      // this.resetForm()
      // if (newEntry.type === 'expense') {
      //   // this.resetForm()
      //   // this.FormLayouts.FrmReceipt = false
      //   // this.FormData.file = null
      //   // setTimeout(() => {
      //   //   this.FormLayouts.FrmReceipt = true
      //   // }, 500)
      // }
    },
    isDuplicated(newEntry) {
      const { type, project, duration, dates, holiday } = newEntry
      const listToCheck =
        type === 'holiday' ? this.items.holidayItems : this.items.listItems

      const uniqueValues = new Set(
        listToCheck.map(function ({
          type,
          project,
          duration,
          dates,
          holidayLabel
        }) {
          return JSON.stringify({
            type,
            project,
            duration,
            dates: dates.join(','),
            holidayLabel
          })
        })
      )
      return uniqueValues.has(
        JSON.stringify({
          type,
          project,
          duration,
          dates: dates.join(','),
          holiday
        })
      )
    },
    sendErrNotif(msg = 'Please check entries and try again.') {
      this.$toasted.error(msg).goAway(3500)
    },
    ObjFilter(obj = {}, predicate) {
      return Object.assign(
        ...Object.keys(obj)
          .filter((key) => predicate(obj[key]))
          .map((key) => ({ [key]: obj[key] }))
      )
    }
  }
}
</script>

<style>
.no-activity-day div span {
  background-color: rgb(236, 143, 143) !important;
  color: #fff !important;
}
.half-activity-day div span {
  background-color: #ccc !important;
  color: #333 !important;
}
.full-activity-day div span {
  background-color: rgb(157, 247, 157) !important;
  color: #333 !important;
}
.bank-holiday-day div span {
  background-color: rgba(200, 200, 200, 0.5) !important;
  color: #fff !important;
}
.holiday-activity-day div span {
  background-color: #eee !important;
}

/* ---- Shared form-field system used across the New Entry / Queue panels ---- */
.lz-form-card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 14px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  padding: 24px 24px 22px;
  height: 100%;
}
.lz-panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #0073be;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f1f5f9;
}
.lz-panel-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(0, 115, 190, 0.1);
  color: #0073be;
  font-size: 14px;
}
.lz-field {
  margin-bottom: 20px;
}
.lz-form-card > .lz-field:last-of-type,
.lz-form-card > .lz-field-row:last-of-type {
  margin-bottom: 0;
}
.lz-field-row {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}
.lz-field-row .lz-field {
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
}
.lz-field-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}
.lz-hint-icon {
  color: #94a3b8;
  cursor: help;
  font-size: 13px;
}
.lz-field .form-control,
.lz-field select.form-control,
.lz-field .custom-select,
.lz-field textarea.form-control {
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 11px 14px;
  font-size: 15px;
  line-height: 1.4;
  color: #1e293b;
  height: auto;
  box-shadow: none;
  background-color: #fff;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}
.lz-field .form-control:focus,
.lz-field select.form-control:focus,
.lz-field .custom-select:focus {
  border-color: #0073be;
  box-shadow: 0 0 0 3px rgba(0, 115, 190, 0.15);
  outline: none;
}
.lz-field .form-control:disabled,
.lz-field select.form-control:disabled {
  background-color: #f1f5f9;
  color: #94a3b8;
}
.lz-form-date {
  width: 100% !important;
}
.lz-form-date .el-input__inner {
  border-radius: 8px !important;
  height: calc(1.4em + 24px) !important;
  font-size: 15px !important;
}
.lz-form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid #f1f5f9;
}
.lz-add-btn.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  border-radius: 8px;
  padding: 11px 24px;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.lz-add-btn.btn .lz-add-btn-spacer {
  visibility: hidden;
}
</style>
